(function (root, factory) {
  var api = factory(root || {});

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.InfrarediUniversalPreorderWidget = api;
  }
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
  'use strict';

  var MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  function monday(date) {
    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate() - ((date.getDay() + 6) % 7)
    );
  }

  function addMonths(date, months) {
    return new Date(date.getFullYear(), date.getMonth() + months, date.getDate());
  }

  function dateKey(date) {
    return date instanceof Date && !isNaN(date.getTime()) ? String(date.getTime()) : '';
  }

  function money(cents, locale, currencyCode) {
    var amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(locale || undefined, {
        style: 'currency',
        currency: currencyCode,
        currencyDisplay: 'narrowSymbol'
      }).format(amount);
    } catch (_error) {
      return '$' + amount.toFixed(2);
    }
  }

  function modelForVariant(variant, options) {
    var dateHelper = root.InfrarediPreorderOfferDate;
    var earliest = dateHelper && dateHelper.dateForVariant({
      variantId: options.variantId,
      marketId: options.marketId,
      offerText: variant.offerText,
      scheduledDate: variant.scheduledDate
    });
    var price = variant.planPriceCents == null ? variant.priceCents : variant.planPriceCents;
    var compareAt = variant.priceCents == null ? variant.compareAtCents : variant.priceCents;
    var depositPercentage = Number(variant.depositPercentage);
    if (!isFinite(depositPercentage) || depositPercentage <= 0) depositPercentage = 100;

    return {
      variantId: String(options.variantId || ''),
      planId: variant.planId,
      earliest: earliest,
      price: Number(price || 0),
      compareAt: Number(compareAt || price || 0),
      depositPercentage: depositPercentage
    };
  }

  function ensureStyle() {
    if (!root.document || root.document.getElementById('ir-universal-preorder-widget-style')) return;
    var style = root.document.createElement('style');
    style.id = 'ir-universal-preorder-widget-style';
    style.textContent = [
      '.ir-universal-preorder{width:100%;margin-top:14px;display:flex;flex-direction:column;gap:14px;font-family:\'Gilroy\',\'Poppins\',-apple-system,BlinkMacSystemFont,sans-serif;-webkit-font-smoothing:antialiased}',
      '.ir-universal-preorder[hidden]{display:none!important}.ir-universal-preorder,.ir-universal-preorder *{box-sizing:border-box}',
      '.ir-universal-preorder .ifrpd-cta{margin:0;display:flex;align-items:center;justify-content:center;gap:12px;width:100%;background:#3234d0;color:#fff;border:0;border-radius:6px;padding:28px 24px;font-family:inherit;font-size:19px;font-weight:800;letter-spacing:.04em;text-transform:uppercase;cursor:pointer;transition:background-color .18s ease}',
      '.ir-universal-preorder .ifrpd-cta:hover,.ir-universal-preorder .ifrpd-cta:focus-visible{background:#484ae0}.ir-universal-preorder .ifrpd-cta[disabled]{opacity:.6;cursor:not-allowed}',
      '.ir-universal-preorder .ifrpd-card{border:1px solid #e2e2e2;border-radius:10px;background:#fff;overflow:hidden}.ir-universal-preorder .ifrpd-head{padding:18px 20px 16px;border-bottom:1px solid #f0f0f0;display:flex;flex-direction:column;gap:6px}',
      '.ir-universal-preorder .ifrpd-badges{display:flex;align-items:center;gap:8px;flex-wrap:wrap}.ir-universal-preorder .ifrpd-badge{background:#ffeef0;color:#e63946;font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;border-radius:999px;padding:5px 10px}.ir-universal-preorder .ifrpd-badge.green{background:#eff8f2;color:#1e8a4c}',
      '.ir-universal-preorder .ifrpd-title{font-size:19px;font-weight:800;color:#272727;line-height:1.2;margin-top:6px}.ir-universal-preorder .ifrpd-bullets{display:flex;flex-direction:column;gap:5px;font-size:14px;color:#878787;line-height:1.5;margin-top:2px}.ir-universal-preorder .ifrpd-bullets div{display:flex;gap:9px}.ir-universal-preorder .ifrpd-bullets .bd{color:#3234d0;flex:none}',
      '.ir-universal-preorder .ifrpd-opts{padding:16px 20px;display:flex;flex-direction:column;gap:10px}.ir-universal-preorder .ifrpd-opt{display:flex;align-items:center;gap:12px;border:1.5px solid #e2e2e2;background:#fff;border-radius:10px;padding:14px 16px;cursor:pointer}.ir-universal-preorder .ifrpd-opt.on{border-color:#3234d0;background:#f5f5fd}',
      '.ir-universal-preorder .ifrpd-dot{width:20px;height:20px;border-radius:999px;border:1.5px solid #c9c9c9;background:#fff;flex:none;display:inline-flex;align-items:center;justify-content:center}.ir-universal-preorder .ifrpd-dot:after{content:"";width:10px;height:10px;border-radius:999px;background:transparent}.ir-universal-preorder .ifrpd-opt.on .ifrpd-dot,.ir-universal-preorder .ifrpd-weekwrap.on .ifrpd-dot{border-color:#3234d0}.ir-universal-preorder .ifrpd-opt.on .ifrpd-dot:after,.ir-universal-preorder .ifrpd-weekwrap.on .ifrpd-dot:after{background:#3234d0}',
      '.ir-universal-preorder .ifrpd-optlbl{font-size:15px;font-weight:700;color:#272727;display:block}.ir-universal-preorder .ifrpd-optsub{font-size:13.5px;color:#3d4246;display:block;margin-top:3px}.ir-universal-preorder .ifrpd-optsub strong{color:#272727}.ir-universal-preorder .ifrpd-weekwrap{border:1.5px solid #e2e2e2;border-radius:10px;overflow:hidden;cursor:pointer}.ir-universal-preorder .ifrpd-weekwrap.on{border-color:#3234d0;background:#f5f5fd}.ir-universal-preorder .ifrpd-weekwrap .ifrpd-opt{border:0;background:transparent;border-radius:0}',
      '.ir-universal-preorder .ifrpd-cal{border-top:1px solid #f0f0f0;padding:14px 16px 16px;cursor:default}.ir-universal-preorder .ifrpd-calnav{display:flex;align-items:center;justify-content:space-between;margin-bottom:10px}.ir-universal-preorder .ifrpd-navbtn{width:32px;height:32px;border:1px solid #e2e2e2;border-radius:6px;background:#fff;color:#272727;padding:0;display:flex;align-items:center;justify-content:center;cursor:pointer}.ir-universal-preorder .ifrpd-navbtn:hover{background:#f7f7f7}.ir-universal-preorder .ifrpd-navbtn[disabled]{color:#d9d9d9;cursor:default}.ir-universal-preorder .ifrpd-callbl{font-size:14px;font-weight:700;color:#272727}',
      '.ir-universal-preorder .ifrpd-dow,.ir-universal-preorder .ifrpd-days{display:grid;grid-template-columns:repeat(7,1fr)}.ir-universal-preorder .ifrpd-dow{margin-bottom:4px}.ir-universal-preorder .ifrpd-dow span{text-align:center;font-size:11px;font-weight:700;color:#878787;text-transform:uppercase;letter-spacing:.06em;padding:4px 0}.ir-universal-preorder .ifrpd-days{row-gap:3px}.ir-universal-preorder .ifrpd-day{height:34px;display:flex;align-items:center;justify-content:center;border-radius:8px;font-size:13.5px;font-weight:500;color:#272727}.ir-universal-preorder .ifrpd-day.off{color:#c9c9c9}.ir-universal-preorder .ifrpd-day.ok{cursor:pointer}.ir-universal-preorder .ifrpd-day.sel{background:#3234d0;color:#fff;font-weight:800;border-radius:0}.ir-universal-preorder .ifrpd-day.sel.wstart{border-radius:8px 0 0 8px}.ir-universal-preorder .ifrpd-day.sel.wend{border-radius:0 8px 8px 0}.ir-universal-preorder .ifrpd-calnote{margin-top:10px;font-size:12.5px;color:#878787;text-align:center}',
      '.ir-universal-preorder .ifrpd-summary{padding:16px 20px;border-top:1px solid #f0f0f0;background:#fbfbfb;display:flex;flex-direction:column;gap:8px}.ir-universal-preorder .ifrpd-row{display:flex;justify-content:space-between;gap:16px;font-size:14px;color:#3d4246}.ir-universal-preorder .ifrpd-row .b{font-weight:800;color:#272727}.ir-universal-preorder .ifrpd-row.due{font-size:13px;color:#878787;border-top:1px dashed #e2e2e2;padding-top:8px}.ir-universal-preorder .ifrpd-row.due .v{font-weight:700;color:#3234d0;text-align:right}.ir-universal-preorder .ifrpd-admin-error{padding:18px 20px;color:#9b1c1c;background:#fff4f4;font-size:14px;line-height:1.45}',
      '@media(max-width:600px){.ir-universal-preorder .ifrpd-day{height:44px}.ir-universal-preorder .ifrpd-navbtn{width:44px;height:44px}.ir-universal-preorder .ifrpd-cta{padding:22px 16px;font-size:16px}.ir-universal-preorder .ifrpd-badges{gap:6px}.ir-universal-preorder .ifrpd-head,.ir-universal-preorder .ifrpd-opts,.ir-universal-preorder .ifrpd-summary{padding-left:14px;padding-right:14px}.ir-universal-preorder .ifrpd-row{font-size:13px}}'
    ].join('');
    root.document.head.appendChild(style);
  }

  function create(options) {
    if (!root.document || !options || !options.purchaseRoot) return null;
    ensureStyle();

    var element = root.document.createElement('div');
    element.className = 'ir-universal-preorder';
    element.setAttribute('data-ir-universal-preorder', '');
    element.hidden = true;

    if (options.anchor && options.anchor.parentNode) {
      options.anchor.parentNode.insertBefore(element, options.anchor.nextSibling);
    } else if (options.form && options.form.parentNode) {
      options.form.parentNode.insertBefore(element, options.form.nextSibling);
    } else {
      options.purchaseRoot.appendChild(element);
    }

    var state = { model: null, mode: 'asap', selectedWeek: null, view: null, adding: false };

    function formatWeek(date) {
      var helper = root.InfrarediPreorderOfferDate;
      return helper ? helper.formatWeek(date) : date.toLocaleDateString(options.locale || undefined, {
        weekday: 'short', day: 'numeric', month: 'long'
      });
    }

    function formatShort(date) {
      return date.toLocaleDateString(options.locale || undefined, { day: 'numeric', month: 'short' });
    }

    function latestWeek() {
      return monday(addMonths(state.model.earliest, 4));
    }

    function deliverySummary() {
      var week = state.mode === 'week' && state.selectedWeek
        ? state.selectedWeek
        : monday(state.model.earliest);
      return 'Week of ' + formatWeek(week);
    }

    function renderCalendar(firstWeek, lastWeek) {
      var view = state.view || new Date(firstWeek.getFullYear(), firstWeek.getMonth(), 1);
      var firstView = new Date(firstWeek.getFullYear(), firstWeek.getMonth(), 1);
      var lastView = new Date(lastWeek.getFullYear(), lastWeek.getMonth(), 1);
      var canPrevious = view.getTime() > firstView.getTime();
      var canNext = view.getTime() < lastView.getTime();
      var firstOffset = (new Date(view.getFullYear(), view.getMonth(), 1).getDay() + 6) % 7;
      var daysInMonth = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
      var html = '<div class="ifrpd-cal" data-stop="1"><div class="ifrpd-calnav">';
      html += '<button type="button" class="ifrpd-navbtn" data-act="prev"' + (canPrevious ? '' : ' disabled') + ' aria-label="Previous month">&larr;</button>';
      html += '<span class="ifrpd-callbl">' + MONTHS[view.getMonth()] + ' ' + view.getFullYear() + '</span>';
      html += '<button type="button" class="ifrpd-navbtn" data-act="next"' + (canNext ? '' : ' disabled') + ' aria-label="Next month">&rarr;</button></div>';
      html += '<div class="ifrpd-dow"><span>Mo</span><span>Tu</span><span>We</span><span>Th</span><span>Fr</span><span>Sa</span><span>Su</span></div><div class="ifrpd-days">';
      for (var i = 0; i < firstOffset + daysInMonth; i += 1) {
        var day = i - firstOffset + 1;
        if (day < 1) {
          html += '<span class="ifrpd-day"></span>';
          continue;
        }
        var date = new Date(view.getFullYear(), view.getMonth(), day);
        var week = monday(date);
        var available = week.getTime() >= firstWeek.getTime() && week.getTime() <= lastWeek.getTime();
        var selected = state.selectedWeek && week.getTime() === state.selectedWeek.getTime();
        var column = i % 7;
        var classes = 'ifrpd-day ' + (available ? 'ok' : 'off');
        if (selected) classes += ' sel' + (column === 0 ? ' wstart' : column === 6 ? ' wend' : '');
        html += '<span class="' + classes + '"' + (available ? ' data-week="' + week.getTime() + '"' : '') + '>' + day + '</span>';
      }
      html += '</div><div class="ifrpd-calnote">Pick any day &mdash; we\'ll reserve that whole week for delivery</div></div>';
      return html;
    }

    function render() {
      var model = state.model;
      if (!model) return;
      var deposit = Math.round(model.price * model.depositPercentage / 100);
      var discount = model.compareAt > 0 ? Math.max(0, Math.round((1 - model.price / model.compareAt) * 100)) : 0;
      var buttonText = model.depositPercentage < 100
        ? money(deposit, options.locale, options.currencyCode) + ' deposit'
        : money(model.price, options.locale, options.currencyCode);
      var html = '<button type="button" class="ifrpd-cta" data-act="cta"' + (model.earliest ? '' : ' disabled') + '><span>Pre-order</span><span style="opacity:.55">&bull;</span><span>' + buttonText + '</span></button>';

      if (!model.earliest) {
        html += '<div class="ifrpd-card"><div class="ifrpd-admin-error">A valid shipping date is required for this pre-order. Add it to the STOQ offer as YYYY-MM-DD.</div></div>';
        element.innerHTML = html;
        return;
      }

      var firstWeek = monday(model.earliest);
      var lastWeek = latestWeek();
      var selectedWeek = state.mode === 'week' && state.selectedWeek;
      html += '<div class="ifrpd-card"><div class="ifrpd-head"><div class="ifrpd-badges"><span class="ifrpd-badge">Pre-order</span>';
      if (discount > 0) html += '<span class="ifrpd-badge green">' + discount + '% off locked in</span>';
      html += '</div><div class="ifrpd-title">Reserve your ' + MONTHS[firstWeek.getMonth()] + ' delivery</div><div class="ifrpd-bullets">';
      if (discount > 0) html += '<div><span class="bd">&bull;</span><span>Lock in today\'s ' + discount + '% discount before it ends</span></div>';
      if (model.depositPercentage < 100) html += '<div><span class="bd">&bull;</span><span>Pay just a ' + model.depositPercentage + '% deposit now &mdash; the rest before dispatch</span></div>';
      html += '<div><span class="bd">&bull;</span><span>Choose the delivery week that suits you</span></div></div></div><div class="ifrpd-opts">';
      html += '<div class="ifrpd-opt' + (selectedWeek ? '' : ' on') + '" data-act="asap"><span class="ifrpd-dot"></span><span><span class="ifrpd-optlbl">As soon as possible</span><span class="ifrpd-optsub">Arrives <strong>week of ' + formatWeek(firstWeek) + '</strong> with the first back-in-stock batch</span></span></div>';
      html += '<div class="ifrpd-weekwrap' + (selectedWeek ? ' on' : '') + '" data-act="week"><div class="ifrpd-opt"><span class="ifrpd-dot"></span><span><span class="ifrpd-optlbl">Choose a delivery week</span><span class="ifrpd-optsub">' + (selectedWeek ? 'Arrives week of <strong>' + formatWeek(state.selectedWeek) + '</strong>' : 'Any week from ' + formatShort(firstWeek) + ' to ' + formatShort(lastWeek)) + '</span></span></div>';
      if (selectedWeek) html += renderCalendar(firstWeek, lastWeek);
      html += '</div></div><div class="ifrpd-summary">';
      if (discount > 0) html += '<div class="ifrpd-row"><span>Price (' + discount + '% off, locked in)</span><span><s>' + money(model.compareAt, options.locale, options.currencyCode) + '</s>&nbsp; <strong>' + money(model.price, options.locale, options.currencyCode) + '</strong></span></div>';
      html += '<div class="ifrpd-row"><span>Due today' + (model.depositPercentage < 100 ? ' (' + model.depositPercentage + '% deposit)' : '') + '</span><span class="b">' + money(deposit, options.locale, options.currencyCode) + '</span></div>';
      if (model.depositPercentage < 100) html += '<div class="ifrpd-row"><span>Balance before dispatch</span><span>' + money(model.price - deposit, options.locale, options.currencyCode) + '</span></div>';
      html += '<div class="ifrpd-row due"><span>Your delivery</span><span class="v">' + deliverySummary() + '</span></div></div></div>';
      element.innerHTML = html;
    }

    async function addToCart(button) {
      if (!state.model || !state.model.planId || !state.model.earliest || state.adding) return;
      state.adding = true;
      button.disabled = true;
      var quantityInput = options.form && options.form.querySelector('input[name="quantity"]');
      var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
      var item = {
        id: state.model.variantId,
        quantity: quantity,
        selling_plan: state.model.planId,
        properties: { 'Requested delivery': deliverySummary() }
      };
      try {
        var routeRoot = root.Shopify && root.Shopify.routes && root.Shopify.routes.root || '/';
        var response = await root.fetch(routeRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        });
        if (!response.ok) throw new Error('Cart add failed');
        root.location.assign(routeRoot + 'checkout');
      } catch (error) {
        console.error('[ir-universal-preorder-widget]', error);
        button.disabled = false;
        state.adding = false;
        options.purchaseRoot.dispatchEvent(new CustomEvent('ir:cart-error', { bubbles: true, detail: { error: error } }));
      }
    }

    element.addEventListener('click', function (event) {
      var day = event.target.closest('[data-week]');
      if (day) {
        state.selectedWeek = new Date(Number(day.getAttribute('data-week')));
        state.mode = 'week';
        render();
        return;
      }
      var action = event.target.closest('[data-act]');
      if (!action) return;
      var name = action.getAttribute('data-act');
      if (name === 'cta') addToCart(action);
      if (name === 'asap') {
        state.mode = 'asap';
        state.selectedWeek = null;
        render();
      }
      if (name === 'week' && !event.target.closest('[data-stop]')) {
        state.mode = 'week';
        state.selectedWeek = state.selectedWeek || monday(state.model.earliest);
        render();
      }
      if ((name === 'prev' || name === 'next') && !action.disabled) {
        event.stopPropagation();
        var current = state.view || new Date(state.model.earliest.getFullYear(), state.model.earliest.getMonth(), 1);
        state.view = new Date(current.getFullYear(), current.getMonth() + (name === 'next' ? 1 : -1), 1);
        render();
      }
    });

    return {
      show: function (variant) {
        var variantId = options.getVariantId();
        var nextModel = modelForVariant(variant, {
          variantId: variantId,
          marketId: options.marketId
        });
        if (!state.model || state.model.variantId !== nextModel.variantId || dateKey(state.model.earliest) !== dateKey(nextModel.earliest)) {
          state.mode = 'asap';
          state.selectedWeek = null;
          state.view = null;
        }
        state.model = nextModel;
        element.hidden = false;
        render();
      },
      hide: function () {
        element.hidden = true;
      },
      element: element
    };
  }

  return {
    monday: monday,
    modelForVariant: modelForVariant,
    create: create
  };
});
